import type { GenericErrorWithSuggestionResponse } from "@globals";
import { List, Stack, Text } from "@mantine/core";

function splitSuggestions(suggestion: string): string[] {
  return suggestion
    .split(".")
    .map(sentence => sentence.trim())
    .filter(Boolean)
    .map(sentence => `${sentence}.`);
}

export default function DatasetParseErrorContent({ error }: { error: GenericErrorWithSuggestionResponse }) {
  const suggestions = splitSuggestions(error.extra.suggestion);

  return (
    <Stack gap="sm">
      <Text size="sm" c="dimmed">
        {error.message}
      </Text>
      {suggestions.length > 0 && (
        <Stack gap={4}>
          <Text size="sm" fw={600}>
            Please correct the following and try again:
          </Text>
          <List size="sm" spacing={2}>
            {suggestions.map(suggestion => (
              <List.Item key={suggestion}>{suggestion}</List.Item>
            ))}
          </List>
        </Stack>
      )}
    </Stack>
  );
}
